import { render, staticRenderFns } from "./EstudianteScreenImportacion.vue?vue&type=template&id=4ee6c76e&scoped=true"
import script from "./EstudianteScreenImportacion.vue?vue&type=script&lang=js"
export * from "./EstudianteScreenImportacion.vue?vue&type=script&lang=js"
import style0 from "./EstudianteScreenImportacion.vue?vue&type=style&index=0&id=4ee6c76e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee6c76e",
  null
  
)

export default component.exports